import React, { useState } from "react";
import TicketsHeader from "../../../Components/Tickets/TicketsHeader";
import TicketList from "../../../Components/Tickets/TicketList";
import { Tabs } from "antd";

import ChirchiqKirim from "../firms/Chirchiq/ChirchiqKirim";
import AmmafosKirim from "../firms/Ammafos/AmmafosKirim";
import KaliyKirim from "../firms/Kaliy/KaliyKirim";

const items = [
  {
    key: "1",
    label: "Max-Chirchiq",
    children: <></>,
    childrens: <ChirchiqKirim />,
  },
  {
    key: "2",
    label: "Olmaliq",
    children: <></>,
    childrens: <AmmafosKirim />,
  },
  {
    key: "3",
    label: "Kaliy",
    children: <></>,
    childrens: <KaliyKirim />,
  },
];

export default function TicketsKirim() {
  let [pageChanges, setPageChanged] = useState(1);

  const onChange = (key) => {
    console.log(key);
    setPageChanged(key);
  };
  return (
    <div>
      <TicketsHeader title="kirim" />

      <div className="max-w-[900px] w-[100%] pb-[70px] m-auto">
        <Tabs
          defaultActiveKey="1"
          className="text-[14px]"
          items={items}
          onChange={onChange}
        />
        {items[pageChanges - 1].childrens}
      </div>
    </div>
  );
}
